import { Link } from "react-router";
import "./not-found-page.scss";

export const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page non trouvée</h2>
        <p>
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="btn-home">
            Retour à l'accueil
          </Link>
          <button onClick={() => window.history.back()} className="btn-back">
            Page précédente
          </button>
        </div>
      </div>
    </div>
  );
};
